import { green } from '@ant-design/colors';
import { CheckCircleOutlined } from "@ant-design/icons";
import { notification } from "antd";
import {
  BackbuttonComponent,
} from "../../../components";
import { useQuery } from "../../../hooks";
import { WorkShopFormPartial } from "../../../partials";
import { useParams } from "react-router-dom";

export const EditWorkShopView = () => {
  const [api, contextHolder] = notification.useNotification();
  const { workshopId } = useParams();
  const { data, execute, loading } = useQuery({
    url: `/workshop/${workshopId}`,
    options: { method: "GET" },
  });
  return loading || !data ? null : (
    <>
      {contextHolder}
      <BackbuttonComponent
      /* style={{
        marginBottom: 16,
        display: "block",
        textAlign: "left",
      }} */
      />
      {/* <FloatButton
        style={{
          top: 64,
          right: "auto",
        }}
        icon={<ArrowLeftOutlined />}
      /> */}
      <WorkShopFormPartial
        method="PUT"
        initialValues={data}
        onSave={(result) => {
          api.open({
            message: <span style={{ color: "#ffffff" }}>¡Éxito!</span>,
            description: (
              <span style={{ color: "#ffffff" }}>
                El taller se actualizó correctamente.
              </span>
            ),
            icon: (<CheckCircleOutlined />),
            style: {
              backgroundColor: green[6],
              border: "1px solid #237804",
              color: "#ffffff",
              borderRadius: "8px",
              boxShadow: "0 4px 15px rgba(0, 0, 0, 0.1)",
              padding: "16px",
            },
            duration: 3, // Duración de la notificación en segundos
          });

          setTimeout(() => {
            execute();
          }, 3000);
        }}
      />
    </>
  );
};

export const EditWorkShopRoute = ({ workshopId }) =>
  `/workshops/${workshopId}/edit`;
